'use client';

import { IosArrowDown, Menu, MenuItem } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import { joinSgcmSite } from '@/utils/url/join/public';

import { COLLAPSIBLE_ARRAOW_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const AutoCompleteQuickBox: Component = ({
  autoCompleteOptions,
  promotionOptions,
  showPromotions = false,
  onIgnoreSearchInputChange,
  onAutoCompleteOptionClick,
}) => {
  const hasAutoCompleteOption = autoCompleteOptions.length > 0;
  const hasPromotions = promotionOptions
    && promotionOptions.length > 0;

  const promotions = promotionOptions && promotionOptions?.length > 4
    ? promotionOptions.slice(0, 4)
    : promotionOptions;

  const handleOptionItemClick = (target: string) => {
    onAutoCompleteOptionClick(target);
    onIgnoreSearchInputChange?.(true);
  };

  return (
    <div className={cx(
      styles.containerRoot,
      !hasPromotions && styles.isSingleColumn,
    )}>
      {hasAutoCompleteOption
      && (
        <Menu className={cx(
          styles.menuRoot,
          hasPromotions && styles.isBorderless,
          hasPromotions && styles.isLeftColumn,
          !hasPromotions && !showPromotions && styles.isSingleColumn,
        )}>
          {autoCompleteOptions.map((option, index) => {
            const key = `autoCompleteOption-${index}`;
            return (
              <MenuItem
                key={key}
                contentClassName={cx(
                  styles.textAutoCompleteOptions,
                  styles.isMultiLines,
                )}
                onClick={() => handleOptionItemClick(option)}>
                {option}
              </MenuItem>
            );
          })}
        </Menu>
      )}
      {hasAutoCompleteOption && hasPromotions && showPromotions
      && (
        <div className={styles.containerPromotions}>
          <Menu className={cx(
            styles.menuRoot,
            styles.isBorderless,
            styles.isRightColumn,
          )}>
            {promotions?.map(({
              id,
              title,
              summary,
              promoType,
              link,
            }) => {
              const key = `autoCompleteOption-${id}`;
              return (
                <MenuItem
                  key={key}
                  contentClassName={cx(
                    styles.promotionMenuItem,
                    styles.hasPaddingBottom,
                  )}
                  onClick={() => {
                    window.open(
                      link,
                      '_self',
                      'noreferrer noopener',
                    );
                  }}>
                  <div className={styles.containerPromotionHeader}>
                    {promoType === 'tactical_ads'
                    && <div className={styles.labelFeatured}>Featured</div>}
                    <div className={styles.textPromotionTitle}>
                      {title}
                    </div>
                  </div>
                  <div className={styles.textPromotionSummary}>
                    {summary}
                  </div>
                </MenuItem>
              );
            })}
          </Menu>
          <a
            href={`${joinSgcmSite('/new_cars/newcars_promotionslist.php')}`}
            target="_self">
            <div className={styles.linkViewAllPromos}>
              View All Promos
              <IosArrowDown
                className={styles.iconArrowRight}
                size={COLLAPSIBLE_ARRAOW_ICON_SIZE} />
            </div>
          </a>
        </div>
      )}
    </div>
  );
};
